import { Chip, Grid, Table } from '@mui/material';
import { styled } from '@mui/system';
import theme from '../../theme';
import AddCommentIcon from '@mui/icons-material/AddComment';
import NotificationIcon from '@mui/icons-material/Notifications';

export const S: { [key: string]: any } = {
    sectionSubtitle: {
        marginBottom: '0.1rem',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '12px',
        marginRight: '10px',
        color: theme.color.white50,
        textWrap: 'wrap'
    },
    sectionTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '19px',
        color: theme.color.white90,
        marginLeft: '0px',
        marginBottom: '10px'
    },
    chatModalDialogContentSx: {
        margin: 0,
        padding: 0
    },
    chatModalDialogSx: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    responsiveSectionSubtitle: {
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        textAlign: {
            xs: 'left',
            sm: 'left',
            md: 'left',
            lg: 'left'
        },
        marginBottom: '0.1rem',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '12px',
        marginRight: '10px',
        color: theme.color.white50
    },
    responsiveSectionSubtitleBoxSx: {
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        textAlign: {
            xs: 'left',
            sm: 'left',
            md: 'left',
            lg: 'left'
        },
        marginBottom: '0.1rem',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '12px',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.color.white50
    },
    newRequestChip: {
        px: {
            xs: 2,
            sm: 2,
            md: 1,
            lg: 1
        },
        height: {
            xs: 32,
            sm: 32,
            md: 28,
            lg: 28
        },
        '& .MuiChip-label': {
            fontSize: {
                xs: 'inherit',
                sm: 'inherit',
                md: 'small',
                lg: 'small'
            }
        }
    },
    rootContainer: {
        paddingLeft: {
            xs: 2,
            sm: 2,
            md: 13,
            lg: 13
        },
        paddingRight: {
            xs: 2,
            sm: 2,
            md: 15,
            lg: 15
        }
    },
    requestsHeaderBoxSx: {
        display: 'flex',
        flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'column',
            lg: 'column'
        },
        alignItems: {
            xs: 'flex-start',
            sm: 'flex-start',
            md: 'flex-start',
            lg: 'flex-start'
        },
        justifyContent: {
            xs: 'space-between',
            sm: 'space-between',
            md: 'flex-start',
            lg: 'flex-start'
        },
        width: '100%'
    },
    mobileSwitchBoxSx: {
        display: {
            xs: 'flex',
            sm: 'flex',
            md: 'none',
            lg: 'none'
        },
        alignItems: 'center'
    },
    actionsContainerSx: {
        display: 'flex',
        flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row'
        },
        alignItems: {
            xs: 'flex-start',
            sm: 'flex-start',
            md: 'center',
            lg: 'center'
        },
        justifyContent: {
            xs: 'flex-start',
            sm: 'flex-start',
            md: 'flex-end',
            lg: 'flex-end'
        },
        gap: {
            xs: 2,
            sm: 2,
            md: 1,
            lg: 1
        },
        width: '100%',
        marginTop: {
            xs: 2,
            sm: 2,
            md: 0,
            lg: 0
        }
    },
    desktopSwitchBoxSx: {
        display: {
            xs: 'none',
            sm: 'none',
            md: 'block',
            lg: 'block'
        },
        width: {
            md: 'auto',
            lg: 'auto'
        },
        marginBottom: {
            md: 0,
            lg: 0
        }
    },
    searchContainerSx: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: 2,
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    searchInputBoxSx: {
        width: {
            xs: '70%',
            sm: '70%',
            md: '100%',
            lg: '100%'
        },
        flex: {
            xs: 'initial',
            sm: 'initial',
            md: '1',
            lg: '1'
        },
        marginRight: {
            xs: 1,
            sm: 1,
            md: 2,
            lg: 2
        }
    },
    addButtonBoxSx: {
        marginLeft: {
            xs: 0,
            sm: 0,
            md: 2,
            lg: 2
        }
    }
};

export const Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 30,
    height: 'fit-content',
    paddingBottom: 50
});

export const SectionHeader = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left'
});

export const SectionHeaderRight = styled(SectionHeader)({
    justifyContent: 'right'
});

export const SectionHeaderLabels = styled(Grid)({
    display: 'flex',
    flexDirection: 'column'
});

export const TabelWrapper = styled(Table)({
    background: '#1E202A'
});

export const SectionHeaderActions = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 40
});

export const AddRowChip = styled(Chip)(({
    marginTop = '15px'
}: {
    marginTop?: string;
}) => {
    return `
    && {
        margin-top: ${marginTop};
        background-color: rgba(255, 220, 168, 0.1);
        border-radius: 16px;
        color: ${theme.color.lightningYellow};
        font-family: 'Inter', sans-serif;
        font-size: 12px;
        line-height: 18px;
        padding-right: 4px;
    }
`;
});

export const StyledAddCommentIcon = styled(AddCommentIcon)`
    && {
        width: 15px;
        height: 15px;
        fill: ${theme.color.lightningYellow};
    }
`;

export const StyledNotificationIcon = styled(NotificationIcon)`
    && {
        width: 15px;
        height: 15px;
        fill: ${theme.color.lightningYellow};
    }
`;

export const StatusText = styled('span')`
    color: ${theme.color.lightningYellow};
    font-family: 'Inter', sans-serif;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    margin-right: 10px;
`;

export const ArrowButton = styled('button')`
    background: ${theme.color.greyYellow};
    flex-direction: row;
    border: none;
    cursor: default;
    display: flex;
    justify-content: center;
    padding: 4px 2px 4px 2px;
    border-radius: 40px;
    width: 100px;
    height: 34px;
    align-items: center;

    svg {
        width: 16px;
        height: 16px;
        cursor: pointer;
        path {
            fill: ${theme.color.lightningYellow};
            transition: fill 0.2s ease;
        }

        &:hover path {
            fill: ${theme.color.yellow60};
        }
    }
`;

export const CircleButton = styled('button')`
    background: ${theme.color.greyYellow};
    cursor: default;
    border: none;
    display: flex;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    align-items: center;

    svg {
        width: 16px;
        height: 16px;
        cursor: pointer;
        &:hover path {
            fill: ${theme.color.yellow60};
        }
    }
`;
